export var removeMessageQuery = function removeMessageQuery(queryName) {
  var _window$location = window.location,
    search = _window$location.search,
    pathname = _window$location.pathname;
  var url = new URLSearchParams(window.location.search.slice(1, search.length));
  url.delete(queryName);
  window.history.pushState({}, document.title, url.size ? "".concat(pathname, "?").concat(url.toString()) : pathname);
};